import { maxWidth600, masterBreakPoint } from "themes/default/breakpoints"

export const styles = {
  dialog: (theme) => ({
    backgroundColor: theme.palette.background.default,
    borderRadius: "24px",
    [maxWidth600]: {
      m: 1,
      width: "calc(100% - 32px)",
      borderRadius: "16px",
    },
  }),
  closeButton: (theme) => ({
    position: "absolute",
    right: 16,
    top: 16,
    border: "none",
    cursor: "pointer",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: theme.palette.background.secondary,
    color: theme.palette.text.lighter1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: theme.palette.hover.main,
      color: theme.palette.common.black,
    },
    zIndex: 10,
  }),
  container: (theme) => ({
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.default,
    p: 2,
    px: 3,
    position: "relative",
  }),
  badgeContainer: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1,
    px: 1,
    py: 0.75,
    borderRadius: "12px",
    border: `1px solid ${theme.palette.hover.main}`,
    backgroundColor: theme.palette.background.default,
    width: "fit-content",
    mb: 2,
  }),
  badgeLabel: (theme) => ({
    fontSize: "0.7rem",
    fontWeight: 700,
    color: theme.palette.licenses.text3,
    textTransform: "uppercase",
  }),
  badgeValue: (theme) => ({
    fontSize: "0.85rem",
    fontWeight: 700,
    color: theme.palette.primary.main,
  }),
  badgeIcon: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: "2.75rem",
  }),
  headerRow: {
    display: "flex",
    flexDirection: { xs: "column-reverse", md: "row" },
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    width: "100%",
    mb: 2,
  },
  headerLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: { xs: "center", md: "flex-start" },
    textAlign: { xs: "center", md: "left" },
    flex: 1,
  },
  lockTitleRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  },
  lockIcon: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: { xs: "2rem", md: "3.5rem" },
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "50%",
    padding: 1,
  }),
  titlePending: (theme) => ({
    fontWeight: 800,
    color: theme.palette.licenses.surface,
    fontSize: "2.8rem",
    lineHeight: "1",
    [masterBreakPoint]: {
      fontSize: "2rem",
    },
  }),
  titlePending2: (theme) => ({
    fontWeight: 800,
    color: theme.palette.primary.main,
    fontSize: "2.8rem",
    lineHeight: "1",
    [masterBreakPoint]: {
      fontSize: "2rem",
    },
    pl: 1,
    mb: 1.25,
  }),
  descriptionText: (theme) => ({
    color: theme.palette.licenses.text3,
    fontSize: "1rem",
    mb: 1,
    pl: 1,
  }),
  savedProgressRow: (theme) => ({
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    color: theme.palette.licenses.actions,
    width: "fit-content",
  }),
  savedProgressIcon: (theme) => ({
    p: 0.75,
    borderRadius: "50%",
    backgroundColor: theme.palette.licenses.border2,
    border: `1px solid ${theme.palette.licenses.border2}`,
    color: theme.palette.licenses.actions,
    fontSize: "3rem",
  }),
  savedProgressText: (theme) => ({
    fontSize: "0.9rem",
    color: theme.palette.licenses.text3,
  }),
  mascotContainer: {
    minHeight: 150,
    height: "20vh",
    objectFit: "contain",
    position: "relative",
    zIndex: 2,
    [maxWidth600]: {
      minHeight: 100,
      height: "15vh",
    },
  },
  mascot: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    position: "relative",
    zIndex: 1,
  },
  sectionDividerRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    mb: 2,
    gap: 2,
  },
  dividerLine: (theme) => ({
    height: "1px",
    backgroundColor: theme.palette.hover.main,
    flex: 1,
  }),
  sectionLabel: (theme) => ({
    color: theme.palette.licenses.text3,
    fontWeight: 700,
    fontSize: "0.85rem",
    textTransform: "uppercase",
  }),
  cardsContainer: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    width: "100%",
    mb: 2,
  },
  card: (theme) => ({
    flex: 1,
    borderRadius: 2.25,
    p: 1.5,
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    textAlign: "left",
    gap: 2,
  }),
  cardIconWrapper: {
    width: 35,
    height: 35,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // mb: 2,
  },
  cardIcon: (theme) => ({
    color: theme.palette.common.white,
    width: 35,
    height: 35,
    p: 1,
  }),
  cardTitle: (theme) => ({
    fontWeight: 700,
    fontSize: "1rem",
    color: theme.palette.licenses.surface,
  }),
  cardDesc: (theme) => ({
    fontSize: "0.85rem",
    color: theme.palette.licenses.surface,
  }),
  bannerContainer: (theme) => ({
    width: "100%",
    backgroundColor: theme.palette.licenses.surface7,
    border: `1px solid ${theme.palette.licenses.surface3}`,
    borderRadius: 2.5,
    p: 2,
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    mb: 3,
  }),
  bannerLeft: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    textAlign: { xs: "center", md: "left" },
    flexDirection: { xs: "column", sm: "row" },
  },
  bannerIconWrapper: (theme) => ({
    width: 35,
    height: 35,
    borderRadius: "50%",
    backgroundColor: theme.palette.primary.main,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  }),
  bannerIcon: (theme) => ({
    color: theme.palette.common.white,
    width: 35,
    height: 35,
    p: 1,
  }),
  bannerText: {
    display: "flex",
    flexDirection: "column",
  },
  bannerTitle: (theme) => ({
    fontWeight: 700,
    fontSize: "0.95rem",
    color: theme.palette.common.black,
  }),
  bannerDesc: (theme) => ({
    fontSize: "0.85rem",
    color: theme.palette.common.black,
  }),
  bannerButton: (theme) => ({
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.85rem",
    borderRadius: "10px",
    px: 2.5,
    py: 0.75,
    flexShrink: 0,
    "&:hover": {
      borderColor: theme.palette.primary.main,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(231,127,51,0.1)"
          : "rgba(254,128,51,0.08)",
    },
  }),
  actionsRow: {
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 2,
    mb: 2,
  },
  btnLater: (theme) => ({
    flex: 1,
    width: { xs: "100%", sm: "auto" },
    borderColor: theme.palette.hover.main,
    color: theme.palette.licenses.text3,
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "12px",
    py: 1.25,
    fontSize: "0.95rem",
    "&:hover": {
      borderColor: theme.palette.hover.main,
      backgroundColor: theme.palette.background.activity,
    },
  }),
  btnReminder: (theme) => ({
    flex: 1,
    width: { xs: "100%", sm: "auto" },
    textTransform: "none",
    fontWeight: 700,
    borderRadius: "12px",
    py: 1.25,
    fontSize: "0.95rem",
  }),
  dividerOr: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 1,
    width: { xs: "100%", sm: "auto" },
    justifyContent: "center",
  },
  dividerOrLine: (theme) => ({
    width: "24px",
    height: "1px",
    backgroundColor: theme.palette.hover.main,
  }),
  dividerOrText: (theme) => ({
    color: theme.palette.menu.contrastText,
    fontSize: "0.85rem",
    fontWeight: 500,
  }),
  footerRow: (theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    color: theme.palette.menu.contrastText,
    mt: 1,
  }),
  footerIcon: {
    fontSize: "0.95rem",
  },
  footerText: {
    fontSize: "0.8rem",
    fontWeight: 500,
  },
}
